import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

import PhotoItems from "./photo_items";
import PhotoUploading from "./photo_uploading";
// import ModalFaceMaskEditor from './modal_face_mask_editor';
import ModalPhotoViewer from "./modal_photo_viewer";
import ModalConfirm from "../modal/modal_confirm";
import ModalAlert from "../modal/modal_alert";
import compressImage from "../../lib/image_compressor";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    album: PropTypes.object.isRequired,
    memberId: PropTypes.number.isRequired,
    loadAllFileCapacityFromServer: PropTypes.func.isRequired,
    loadAlbumFileCapacityFromServer: PropTypes.func.isRequired,
    canUploadPrivateStrage: PropTypes.bool.isRequired,
    myMemberType: PropTypes.number.isRequired,
  },
  getInitialState() {
    return {
      loading: false,
      uploadingPhoto: false,
      photoList: { photos: [] },
      isModalOpen: false,
      modalPhotoIndex: 0,
      modalPhotoUrl: "",
      modalPhotoDir: "photo-w",
      modalPhotoUploadedDate: "",
      isPhotoSaved: false,
      isDeleteMode: false,
      isFaceMaskMode: false,
      scrollPos: 0,
      selectedPhotoId: 0,
    };
  },
  componentDidMount() {
    this.loadAlbumPhotosFromServer();
    window.addEventListener("beforeunload", this.onUnload);
  },
  onUnload(event) {
    if (!this.state.isPhotoSaved) {
      event.returnValue = "";
    }
  },
  SetModalPhotoDirection(url) {
    var img = new Image();
    img.src = url;
    var width = img.width;
    var height = img.height;
    var dispAspectRatio = (window.innerWidth / window.innerHeight).toFixed(2);
    var picAspectRatio = (width / height).toFixed(2);
    var direction =
      dispAspectRatio - picAspectRatio < 0 ? "photo-w" : "photo-h";
    this.setState({
      modalPhotoDir: direction,
    });
  },
  changeDeleteMode() {
    if (!this.state.isDeleteMode) {
      this.setState({
        isFaceMaskMode: false,
      });
    }
    this.setState({
      isDeleteMode: !this.state.isDeleteMode,
    });
  },
  changeFaceMaskMode() {
    if (!this.state.isFaceMaskMode) {
      this.setState({
        isDeleteMode: false,
      });
    }
    this.setState({
      isFaceMaskMode: !this.state.isFaceMaskMode,
    });
  },
  closeModal() {
    $(document.body).css({
      position: "relative",
      marginTop: "0",
      marginLeft: "0",
    });
    $(window).scrollTop(this.state.scrollPos);
    this.setState({
      isModalOpen: false,
    });
  },
  openModal(e) {
    var scrollPos = window.pageYOffset;
    var marginLeft =
      (window.innerWidth - $("body .container").outerWidth()) / 2;
    $(document.body).css({
      position: "fixed",
      marginTop: -scrollPos,
      marginLeft: marginLeft,
    });
    var url = this.state.photoList.photos[e].safe_image;
    this.SetModalPhotoDirection(url);
    var uploaded_date = this.state.photoList.photos[e].uploaded_date;
    this.setState({
      isModalOpen: true,
      modalPhotoIndex: e,
      modalPhotoUrl: url,
      modalPhotoUploadedDate: uploaded_date,
      scrollPos: scrollPos,
    });
  },
  changePhoto(e) {
    var index = e;
    var photoCount = this.state.photoList.photos.length;
    if (index < 0) {
      index = photoCount - 1;
    } else if (index > photoCount - 1) {
      index = 0;
    }
    var url = this.state.photoList.photos[index].safe_image;
    this.SetModalPhotoDirection(url);
    var uploaded_date = this.state.photoList.photos[index].uploaded_date;
    this.setState({
      modalPhotoIndex: index,
      modalPhotoUrl: url,
      modalPhotoUploadedDate: uploaded_date,
    });
  },
  addPhotoToServer(file) {
    if (!file) {
      return;
    }
    this.setState({
      uploadingPhoto: true,
    });
    var formData = new FormData();
    formData.append("file", file);
    formData.append("album_id", this.props.album.id);
    formData.append("public_type", this.props.album.public_type);
    formData.append("member_id", this.props.memberId);
    formData.append("circle_id", this.props.album.circle_id);
    $.ajax({
      url: "/api/album/add_photo",
      type: "POST",
      dataType: "json",
      data: formData,
      cache: false,
      processData: false,
      contentType: false,
      success: function(data) {
        if (data) {
          this.loadAlbumPhotosFromServer();
          this.props.loadAllFileCapacityFromServer();
          if (this.props.album.public_type == 2) {
            this.props.loadAlbumFileCapacityFromServer();
          }
        } else {
          this.setState({
            uploadingPhoto: false,
          });
          this.modalAlertFileError.openModal();
        }
      }.bind(this),
      error: function() {
        this.setState({
          uploadingPhoto: false,
        });
        this.modalAlertFileError.openModal();
      }.bind(this),
    });
  },
  loadAlbumPhotosFromServer() {
    $.ajax({
      url: "/api/album/get_photos",
      type: "POST",
      dataType: "json",
      data: {
        album_id: this.props.album.id,
      },
      cache: false,
      success: function(data) {
        this.setState({
          loading: false,
          photoList: data,
          uploadingPhoto: false,
          isPhotoSaved: data.photos.length > 0,
        });
      }.bind(this),
      error: function() {
        this.setState({
          uploadingPhoto: false,
        });
      }.bind(this),
    });
  },
  async handleInputFileField(e) {
    var file = e.target.files[0];
    file = await compressImage(file);
    if (this.props.canUploadPrivateStrage) {
      this.addPhotoToServer(file);
    } else if (this.props.album.public_type == 4) {
      this.addPhotoToServer(file);
    } else {
      this.modalAlertStrageOver.openModal();
    }
  },
  deletePhotoFromServer() {
    $.ajax({
      url: "/api/album/delete_photo",
      type: "POST",
      dataType: "json",
      data: {
        photo_id: this.state.selectedPhotoId,
      },
      cache: false,
      success: function(data) {
        if (data) {
          this.loadAlbumPhotosFromServer();
          this.props.loadAlbumFileCapacityFromServer();
          this.props.loadAllFileCapacityFromServer();
        } else {
          this.modalAlertDeleteError.openModal();
        }
      }.bind(this),
      error: function() {
        this.modalAlertNetworkError.openModal();
      }.bind(this),
    });
  },
  deletePhotoSelected(e) {
    this.setState({
      selectedPhotoId: e,
    });
    this.modalConfirmDeletePhoto.openModal();
  },
  faceMaskPhotoSelected(index, photoId) {
    var url = this.state.photoList.photos[index].safe_image;
    this.SetModalPhotoDirection(url);
    this.setState(
      {
        selectedPhotoId: photoId,
        modalPhotoIndex: index,
        modalPhotoUrl: url,
        isFaceMaskMode: false,
      },
      function() {
        this.modalFaceMaskEditor.openFaceMaskEditor();
      }
    );
  },
  deletePhoto() {
    this.deletePhotoFromServer();
  },
  render() {
    let deleteModeButtonColor = this.state.isDeleteMode ? "#000" : "#cacaca";
    var photos = this.state.photoList.photos.map(function(item, index) {
      return (
        <PhotoItems
          index={index}
          photo={item}
          openModal={this.openModal}
          key={item.id}
          isPhotoDeletebuttonActive={this.state.isDeleteMode}
          isFaceMaskButtonActive={this.state.isFaceMaskMode}
          deletePhotoSelected={this.deletePhotoSelected}
          faceMaskPhotoSelected={this.faceMaskPhotoSelected}
        />
      );
    }, this);
    var photoList = (
      <div className="sorting-block album">
        <div className="sorting-grid">
          {this.props.myMemberType === 1 ? (
            <li
              className="col-md-3 col-sm-3 col-xs-4 photo-list"
              style={{ opacity: this.state.uploadingPhoto ? "0.5" : "1.0" }}
            >
              <label
                className="photo-wrap"
                style={{ border: "2px dashed #d2d2d2", borderRadius: "5px" }}
              >
                <a
                  className="photo-h"
                  style={{ textAlign: "center", color: "#ccc" }}
                >
                  <br />
                  <i
                    className="fas fa-plus"
                    aria-hidden="true"
                    style={{ fontSize: "40px" }}
                  />
                  <p style={{ color: "#ccc" }}>追加</p>
                </a>
                <input
                  type="file"
                  className="form_file_photo"
                  style={{ display: "none" }}
                  onChange={(e) => this.handleInputFileField(e)}
                  disabled={this.state.uploadingPhoto}
                />
              </label>
            </li>
          ) : (
            ""
          )}
          <PhotoUploading isActive={this.state.uploadingPhoto} />
          {photos}
        </div>
      </div>
    );
    return (
      <div>
        {this.props.myMemberType === 1 ? (
          <div style={{ fontSize: "25px", height: "15px", padding: "1px" }}>
            <a
              className={this.state.isDeleteMode ? "shake" : ""}
              onClick={this.changeDeleteMode}
              style={{
                float: "right",
                marginTop: "-23px",
                marginRight: "0px",
                color: deleteModeButtonColor,
              }}
            >
              <i className="fas fa-trash-alt" aria-hidden="true" />
            </a>
          </div>
        ) : (
          ""
        )}
        <ModalPhotoViewer
          isOpen={this.state.isModalOpen}
          onClose={this.closeModal}
          onChange={this.changePhoto}
          photoIndex={this.state.modalPhotoIndex}
          photoUrl={this.state.modalPhotoUrl}
          photoDir={this.state.modalPhotoDir}
          photoUploadedDate={this.state.modalPhotoUploadedDate}
        />
        {photoList}
        <ModalConfirm
          ref={(c) => {
            this.modalConfirmDeletePhoto = c;
          }}
          title="画像の削除"
          content="元に戻すことはできません。よろしいですか？"
          approveFunc={this.deletePhoto}
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertFileError = c;
          }}
          title="ファイルエラー"
          content="選択したファイルが画像ファイルであることを確認してください。"
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertDeleteError = c;
          }}
          title="エラー"
          content="時間を置いてもう一度試すか、運営にお問い合わせください。"
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertNetworkError = c;
          }}
          title="エラー"
          content="ネットワークエラーが発生しました。ネットワークの接続を確認し、もう一度試してください。"
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertStrageOver = c;
          }}
          title="容量制限"
          content="プライベートストレージの制限を超えています。画像を投稿するには、アルバムの公開範囲を「公開」に設定するか、他の画像を削除してください。有料プランに加入するとプライベートストレージの制限を解除できます。"
        />
      </div>
    );
  },
});
